"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = exports.Loading = void 0;
const mithril_1 = __importDefault(require("mithril"));
const helpers_1 = require("../utils/helpers");
exports.Loading = {
    view() {
        return (0, mithril_1.default)("div", { class: "fa-3x loading-box" }, (0, helpers_1.iconSpan)("fa-spinner fa-pulse"));
    }
};
exports.Error = {
    view(vnode) {
        let content = vnode.attrs.error_message;
        content = content || vnode.attrs.error_code;
        content = content || "Erreur inattendue. Veuillez recharger la page";
        return (0, mithril_1.default)("div", { class: "message is-danger" }, (0, mithril_1.default)("div", { class: "message-body" }, (0, mithril_1.default)("p", content)));
    }
};
